import type { IProps, ModalFooterActionsFactory } from "./modal-footer-actions.types";
import styles from "../../modal.module.scss";
import { componentWrapper } from "../../../../utilities";
import { Group } from "../../../group";
import { ModalFooterActionsRemove } from "./modal-footer-actions-remove";
import { ModalFooterActionsCancel } from "./modal-footer-actions-cancel";
import { ModalFooterActionsDone } from "./modal-footer-actions-done";

const ModalFooterActions = componentWrapper<ModalFooterActionsFactory, IProps>("ModalFooterActions", (props, ref) => {
    return <Group ref={ref} gap="sm" justify="flex-end" className={styles["footer-actions"]} {...props} />;
});

ModalFooterActions.Remove = ModalFooterActionsRemove;
ModalFooterActions.Cancel = ModalFooterActionsCancel;
ModalFooterActions.Done = ModalFooterActionsDone;

export { ModalFooterActions };
